import axios from "../../axios/index.js"


export default {
  getAll(no, today, numero) {
    return axios.get("retours/" + no + "/" + today + "/" + numero, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  ValiderRetour(list_retour) {
    return axios.post("retours", list_retour, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  GetAll2(no) {
    return axios.get("/reporting/listRetour/" + no , { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  Get(no){
    return axios.get("/reporting/detail/retour", {params: {code : no}},{ headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
}
}